import { render } from "./custom-form.vue?vue&type=template&id=c77bf0e6&lang=pug"
import script from "./custom-form.vue?vue&type=script&lang=js"
export * from "./custom-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__